"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateItemParams = void 0;
const index_js_1 = require("../../../../entity/actions/parse/index.js");
const isEmpty_js_1 = require("../../../../utils/isEmpty.js");
const omit_js_1 = require("../../../../utils/omit.js");
const index_js_2 = require("../updateExpression/index.js");
const index_js_3 = require("./extension/index.js");
const parseUpdateItemOptions_js_1 = require("./parseUpdateItemOptions.js");
const updateItemParams = (entity, input, options = {}) => {
    var _a;
    const { parsedItem, item, key } = entity.build(index_js_1.EntityParser).parse(input, {
        mode: 'update',
        parseExtension: index_js_3.parseUpdateExtension
    });
    const { ExpressionAttributeNames: updateExpressionAttributeNames, ExpressionAttributeValues: updateExpressionAttributeValues, ...update } = (0, index_js_2.parseUpdate)(entity, (0, omit_js_1.omit)(item, ...Object.keys(key)));
    const { ExpressionAttributeNames: optionsExpressionAttributeNames, ExpressionAttributeValues: optionsExpressionAttributeValues, ...awsOptions } = (0, parseUpdateItemOptions_js_1.parseUpdateItemOptions)(entity, options);
    const ExpressionAttributeNames = {
        ...optionsExpressionAttributeNames,
        ...updateExpressionAttributeNames
    };
    const ExpressionAttributeValues = {
        ...optionsExpressionAttributeValues,
        ...updateExpressionAttributeValues
    };
    return {
        TableName: (_a = options.tableName) !== null && _a !== void 0 ? _a : entity.table.getName(),
        /**
         * @debt type "TODO: Rework extensions & not cast here (use `ParsedItem<ENTITY, { extension: UpdateItemExtension }>`)"
         */
        ToolboxItem: parsedItem,
        Key: key,
        ...update,
        ...awsOptions,
        ...(!(0, isEmpty_js_1.isEmpty)(ExpressionAttributeNames) ? { ExpressionAttributeNames } : {}),
        ...(!(0, isEmpty_js_1.isEmpty)(ExpressionAttributeValues) ? { ExpressionAttributeValues } : {})
    };
};
exports.updateItemParams = updateItemParams;
